import api from '../token';

export const AddBanco = async (dados) => {
  try {
    const response = await api.post('/addBanco', dados);
    return response.data;
  } catch (error) {
   
    return [];
  }
};


